import { faArchive, faCircle, faFolderOpen, faLayerGroup, faUser, faUserSlash } from '@fortawesome/pro-solid-svg-icons';
import type { Features } from '~/provides/features.types';
import type { Thread } from '~/services/threads/threadsClient.types';

type ThreadIdentity = Pick<Thread, 'contact_id' | 'group_id'>;
type SuggestionThread = Pick<Thread, 'status' | 'thread_section'> | null | undefined;

export function canUseMessageHub(): boolean {
    const onCorporate = !Spark.state.currentOrgUnit?.id && !Spark.state.currentGroup?.group_id;

    return onCorporate || !Spark.state.currentTeam.groups_use_corporate_numbers;
}

export function getStatusForInbox(inbox?: string | null): string | undefined {
    if (!inbox || inbox === 'all') {
        return undefined;
    }

    if (inbox === 'me') {
        return 'open';
    }

    if (inbox === 'unassigned') {
        return 'unassigned';
    }

    if (inbox === 'open') {
        return 'open';
    }

    if (inbox === 'closed') {
        return 'closed';
    }

    return undefined;
}

export function isSameThread(a: ThreadIdentity, b: ThreadIdentity): boolean {
    return a.contact_id === b.contact_id && (a.group_id ?? null) === (b.group_id ?? null);
}

export function shouldShowThreadSuggestion(
    features: Pick<Features, 'message_hub_ai' | 'simple_message_hub' | 'contact_groups'>,
    thread: SuggestionThread
): boolean {
    if (!thread) {
        return false;
    }

    if (!Spark.isPlatformAdmin && !Spark.isImpersonating) {
        return false;
    }

    if (!features.message_hub_ai) {
        return false;
    }

    if (!features.contact_groups) {
        return false;
    }

    if (!Spark.state.currentGroup) {
        return false;
    }

    if (thread.thread_section === 'snoozed' || thread.thread_section === 'completed') {
        return false;
    }

    if (thread.status === 'closed' && !features.simple_message_hub) {
        return false;
    }

    return true;
}

export const getInboxIcon = (key?: string) => {
    const inboxIcons = {
        me: faUser,
        unassigned: faUserSlash,
        open: faFolderOpen,
        closed: faArchive,
        all: faLayerGroup,
    };

    if (!key || !(key in inboxIcons)) {
        return faCircle;
    }

    return inboxIcons[key as keyof typeof inboxIcons];
};
